<template>
    <q-card class="shadow-0">
        <q-card-section>
            <div class="row justify-between">
                <div class="text-h6">Seguridad <span class="text-subtitle2 text-grey">Cambia tu contraseña para mantener
                        tu cuenta segura.</span></div>
                <q-btn outline icon="save" label="Cambiar contraseña" color="primary" type="submit"
                    :loading="cargando" />
            </div>

        </q-card-section>
        <q-separator />
        <q-card-section>
            <div class="row q-col-gutter-md">
                <div class="col-12 ">
                    <q-input dense outlined v-model="form.passwordActual" label="Contraseña actual" type="password"
                        :rules="[val => !!val || 'Este campo es obligatorio']" />
                </div>
                <div class="col-12 ">

                    <q-input dense outlined v-model="form.nuevaPassword" label="Nueva contraseña" type="password"
                        :rules="[
                            val => !!val || 'Este campo es obligatorio',
                            val => val.length >= 8 || 'Debe tener al menos 8 caracteres'
                        ]" />
                </div>
                <div class="col-12 ">
                    <q-input dense outlined v-model="form.confirmarPassword" label="Confirmar nueva contraseña"
                        type="password" :rules="[
                            val => !!val || 'Este campo es obligatorio',
                            val => val === form.nuevaPassword || 'Las contraseñas no coinciden'
                        ]" />
                </div>
            </div>

        </q-card-section>

    </q-card>
</template>

<script>
export default {
    data() {
        return {
            form: {
                passwordActual: '',
                nuevaPassword: '',
                confirmarPassword: ''
            },
            cargando: false
        }
    },
    methods: {
        async cambiarPassword() {
            this.cargando = true
            try {
                // Aquí va tu llamada a API, ejemplo:
                await this.$axios.post('/api/cambiar-password', this.form)

                this.$q.notify({
                    type: 'positive',
                    message: 'Contraseña actualizada exitosamente'
                })

                // Limpiar formulario
                this.form.passwordActual = ''
                this.form.nuevaPassword = ''
                this.form.confirmarPassword = ''
            } catch (error) {
                this.$q.notify({
                    type: 'negative',
                    message: error.response?.data?.message || 'Error al cambiar contraseña'
                })
            } finally {
                this.cargando = false
            }
        }
    }
}
</script>